import {useState, useEffect } from "react";
import SVGIcons from "../../SVGIcons";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import LoadingScreen3 from "../../components/LoadingScreen3";
import PopupError from "../../components/PopupError";

const AdminUsers = () => {
    const [isLoading, setIsLoading] =useState(true);

    const navigate = useNavigate();

    const [allUserList, setAllUserList] = useState([]);
    const [currentList, setCurrentList] = useState([]);
    
    const [currentPage, setCurrentPage] = useState(1);

    const [searchWord, setSearchWord] = useState('');

    const fetchAllUsers = async (page, size, search = '') => {
        setIsLoading(true);
        try {
            const response = await axios.get(`https://cleanez-api.vercel.app/api/admin/findAllUsers`, 
                {params: { 
                    page: page, 
                    pageSize: size ,
                    keyword: search}
                }
            );

            setAllUserList(response.data.userList)
        } catch (e) {
            console.log(e);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchAllUsers(1, 10, searchWord);
    }, [])

    useEffect(() => {
        // console.log("All User List: ", allUserList);
        setCurrentList(allUserList);
    }, [allUserList])

    useEffect(() => {
        // console.log("Current List: ", currentList)
    }, [currentList])

    const handleSearch = (search) => {
        setCurrentList(allUserList.filter((user) => 
            user.firstname.toLowerCase().includes(search.toLowerCase()) || 
        user.lastName.toLowerCase().includes(search.toLowerCase())
        ));
    };
    
    const handleDeleteButton = async (id) => {
        // console.log(id);
        try {
            const response = await axios.delete(`https://cleanez-api.vercel.app/api/admin/deleteUser/${id}`);
            if(response.status === 200){
                fetchAllUsers(1, 10);
            }
        } catch (e) {
            console.log(e);
            setErrMessage(e.message);
            setShowErrorModal(true);
        }
    }

    const handlePages = (destination) => {
        if (destination === "next" && !(currentList.length === 0 || currentList.length < 10)) {
            setCurrentPage(currentPage + 1)
        } else if (destination === "prev" && currentPage != 1) {
            setCurrentPage( currentPage - 1)
        }
    }

    useEffect(() => {
        fetchAllUsers(1, 10, searchWord);
    }, [searchWord])

    useEffect(() => {
        fetchAllUsers(currentPage, 10, searchWord);
    }, [currentPage])

    const handleStatus = async (id) => {
        try {
            const response = await axios.put(`https://cleanez-api.vercel.app/api/admin/updateUserStatus/${id}`);

            console.log(response);
        } catch (e) {
            console.log(e);
            setErrMessage(e.message);
            setShowErrorModal(true);
        } finally {
            fetchAllUsers(currentPage, 10, searchWord);
        }
    }

    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errMessage, setErrMessage] = useState("");

    const handleContinue = () => {
        setShowErrorModal(false);
        setErrMessage("");
    }

    return (  
        <>
            {showErrorModal? 
                <PopupError 
                errTitle="Unable to Save Profile"
                errMessage={errMessage}
                buttons={[
                    {func: () => {}, text: "", className: "none"},
                    {func: handleContinue, text: "Cancel", className: "red"},
                ]}/> :
                <></>
            }
            <div className="dashboard-page">
            <section className="dashboard-upcoming-container">
                <div className="admin-searchbar-container">
                    <input 
                    type="text" 
                    placeholder="Search"
                    className="dashboard-searchbar"
                    name="dashboard-searchbar" 
                    id="dashboard-searchbar" 
                    onChange={(e) => setSearchWord(e.target.value)}/>

                    <button
                    type="button"
                    className="act-btn complete add-new"
                    onClick={(e) => navigate('new-user')}>
                        Add New User
                    </button>
                </div>
                <div className="dashboard-list-container">
                    <table className="dashboard-list-table">
                        <thead className="dashboard-thead">
                            <tr>
                                <th className="dashboard-th tb-left">Name</th>
                                <th className="dashboard-th tb-left">Address</th>
                                <th className="dashboard-th tb-center">Status</th>
                                <th className="dashboard-th tb-center">Verified</th>
                                <th className="dashboard-th tb-center">Last Logged In</th>
                                <th className="dashboard-th tb-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                        {isLoading ?
                            <tr>
                                <td colSpan="6"><LoadingScreen3 /></td>
                            </tr> :
                        currentList.map((user, index) => (
                            <tr 
                            key={index} 
                            className="dashboard-tbody-tr"
                            onDoubleClick={(e) => {navigate(`${user.userId}`)}}>
                                <td className="dashboard-tbody-td tb-left">
                                    {user.firstname} {user.lastName}
                                </td>
                                <td className="dashboard-tbody-td tb-left">
                                    {user.address.barangay}, {user.address.municipal}, {user.userId.province} 
                                </td>
                                <td className="dashboard-tbody-td tb-center">
                                    <div className={`dashboard-status 
                                    ${String(user.status).toLowerCase()}`}
                                    onClick={() => handleStatus(user.userId)}>
                                        {user.status}
                                    </div>
                                </td>
                                    
                                <td className="dashboard-tbody-td tb-center">
                                {(user.isVerified) ? 
                                    <SVGIcons 
                                    selected="badgeVerified"
                                    size="24px"
                                    color="#06E36D"/> :
                                    <SVGIcons 
                                    selected="badgeNotVerified"
                                    size="24px"
                                    color="#CC3363"/>
                                }
                                </td>
                                <td className="dashboard-tbody-td tb-center">
                                    {user.lastLogin.replace(", ", " ")}
                                </td>
                                <td className="dashboard-tbody-td tb-center">
                                    <SVGIcons 
                                    selected="trash"
                                    size="24px"
                                    color="#CC3363"
                                    onClick={(e) => {handleDeleteButton(user.userId)}}/>
                                </td>
                            </tr> 
                        ))}
                            
                       
                        </tbody>
                    </table>
                    <div className="dashboard-list-navigation">
                        <SVGIcons 
                        selected="previousArrow"
                        size="32px"
                        color="#222222"
                        onClick={(e) => handlePages("prev")}/>
                        <h2>{currentPage}</h2>
                        <SVGIcons 
                        selected="forwardArrow"
                        size="32px"
                        color="#222222"
                        onClick={(e) => handlePages("next")}/>
                    </div>
                </div>
            </section>
            </div>
        </>

        
    );
}
 
export default AdminUsers;